import { NetworkStatsSection } from './sections/NetworkStatsSection'
import { DeviceStatsSection } from './sections/DeviceStatsSection'
import { ProAudioStatsSection } from './sections/ProAudioStatsSection'
import { SystemStats, systemStatsEmitter } from '@/functionalities/SystemStats/SystemStats'
import { useEffect, useState } from 'react'

export function Statistics() {
    const [systemStats, set_systemStats] = useState<SystemStats>({
        rtcOverviewStats: null,
        mediaTrackStats: null,
        systemResourceUsageStats: null,
        pingMeasurement: null,
        audioEngineNetworkStats: { serverPing: null },
        audioEnginePerStreamReceptionStats: null,
        midiStats: { rxCount: 0, txCount: 0 },
    })

    const [aeNetworkStats, set_aeNetworkStats] = useState<{ serverPing: number | null }>({ serverPing: null })

    useEffect(() => {
        const handler = (data: SystemStats) => {
            set_systemStats(data)
        }

        let timer = setInterval(() => {
            set_aeNetworkStats(
                // @ts-ignore
                window.audioEngineNetworkStats || {}
            )
        }, 3000)

        systemStatsEmitter.addListener('data', handler)
        return () => {
            systemStatsEmitter.removeListener('data', handler)
            clearInterval(timer)
        }
    }, [])

    return (
        <div className="flex flex-col gap-[10px]">
            <NetworkStatsSection systemStats={systemStats} aeNetworkStats={aeNetworkStats} />
            <DeviceStatsSection systemStats={systemStats} />
            <ProAudioStatsSection aeNetworkStats={aeNetworkStats} />
        </div>
    )
}
